import { useAlertContext } from "@shared";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { srvProceedingApi } from "@/api";
import { withLocalErrorHandling } from "@/api/middleware/errorMiddleware";
import { QueryKey } from "@/query/Query";
import { useTranslation } from "@/translations";

import { getSrvProceedingErrorMessage } from "../SrvProceedingTab.utils";

const TRANSLATION_BASE = "clients.client.debtSettlement.srvProceeding.claimsSnapshot";

/**
 * Re-takes the Verbindlichkeiten snapshot from the client's current claims. Safe next to unsaved form
 * edits: the response only differs in the snapshot, so the form's initial values stay equal and Formik
 * keeps what was typed.
 */
export function useRefreshClaimsSnapshot(clientId: string) {
  const { t } = useTranslation();
  const { showSuccess, showError } = useAlertContext();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (proceedingId: string) =>
      srvProceedingApi.refreshSrvProceedingClaimsSnapshot({ clientId, proceedingId }, withLocalErrorHandling),
    onSuccess: (refreshed) => {
      queryClient.setQueryData([QueryKey.SrvProceeding, clientId, refreshed.id], refreshed);
      showSuccess(t(`${TRANSLATION_BASE}.refreshSuccess`));
    },
    onError: (error) => showError(getSrvProceedingErrorMessage(error, t, t(`${TRANSLATION_BASE}.refreshFailed`))),
  });
}
